import {CommonResponse, BaseRequestParams, instance} from "./API"
import {AxiosResponse} from "axios"

export const appApi = {
    getStatistics(params: BaseRequestParams): Promise<CommonResponse<StatisticsResponse>> {
        const {controller} = params
        return instance.get(`app/statistics`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type StatisticsResponse = {
    totalUsers: number
    totalObjects: number
    totalPSLeakDevices: number
    offlinePSLeakDevices: number
    problemPSLeakDevices: number
    totalLogs: number
}